module.exports = __webpack_public_path__ + "img/delete-bin-white.bd20c424.svg";